import { motion } from "framer-motion";
import { MATCH_PROJECT, MATCH_CONTEXT } from "../lib/professionals";
import { fadeUp, viewportOnce } from "../lib/motion";

const TransparentMatching = () => (
    <section
        data-testid="transparent-matching"
        className="relative border-y border-white/10 bg-surface/40 py-24 lg:py-36"
    >
        <div className="mx-auto max-w-[1600px] px-6 md:px-10 lg:px-16">
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="show"
                viewport={viewportOnce}
                className="flex items-center gap-6"
            >
                <p className="font-mono text-[13px] tracking-[0.3em] text-mist">
                    TRANSPARENT MATCHING
                </p>
                <span className="h-px flex-1 bg-white/10" />
                <p className="font-mono text-[13px] tracking-[0.3em] text-cad">
                    MT.01
                </p>
            </motion.div>

            <div className="mt-14 grid items-center gap-14 lg:grid-cols-12">
                <div className="lg:col-span-5">
                    <motion.h2
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={viewportOnce}
                        data-testid="matching-headline"
                        className="font-display text-4xl font-semibold leading-[1.12] text-white md:text-5xl"
                    >
                        KNOW EXACTLY WHY YOU WERE MATCHED
                        <span className="text-accent">.</span>
                    </motion.h2>
                    <motion.p
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={viewportOnce}
                        className="mt-6 max-w-md text-[16px] leading-relaxed text-mist"
                    >
                        BuildEase matching is explained through context — the
                        project, its location, and the experience and services
                        relevant to it. Never an unexplained score.
                    </motion.p>
                    <motion.p
                        variants={fadeUp}
                        initial="hidden"
                        whileInView="show"
                        viewport={viewportOnce}
                        className="mt-8 flex items-center gap-3 font-mono text-[13px] tracking-[0.22em] text-cad"
                    >
                        <span className="h-1 w-1 bg-accent" />
                        NO PERCENTAGES. NO BLACK-BOX RANKING.
                    </motion.p>
                </div>

                <motion.div
                    variants={fadeUp}
                    initial="hidden"
                    whileInView="show"
                    viewport={viewportOnce}
                    className="lg:col-span-7"
                >
                    <div className="mb-4 flex items-center justify-between font-mono text-[13px] tracking-[0.2em] text-cad">
                        <span>FIG. MT.01 — MATCH CONTEXT</span>
                        <span>1 : 1</span>
                    </div>
                    <div
                        data-testid="matching-card"
                        className="border border-white/15 bg-[#0C1428] shadow-[0_24px_60px_rgba(0,0,0,0.45)]"
                    >
                        <div className="flex items-start justify-between border-b border-white/10 px-6 py-5 md:px-8">
                            <div>
                                <p className="font-mono text-[13px] tracking-[0.22em] text-cad">
                                    PROJECT
                                </p>
                                <h3 className="mt-2 font-display text-xl font-semibold tracking-tight text-white md:text-2xl">
                                    {MATCH_PROJECT}
                                </h3>
                            </div>
                            <span className="border border-accent/60 px-2.5 py-1 font-mono text-[13px] tracking-[0.22em] text-accent">
                                SAMPLE UI
                            </span>
                        </div>

                        <p className="px-6 pt-5 font-mono text-[13px] tracking-[0.22em] text-cad md:px-8">
                            MATCH CONTEXT
                        </p>
                        <div className="px-6 pb-2 pt-3 md:px-8">
                            {MATCH_CONTEXT.map((c, i) => (
                                <div
                                    key={c}
                                    data-testid={`match-context-${i + 1}`}
                                    className="flex items-center gap-3.5 border-t border-white/[0.07] py-3.5 first:border-t-0"
                                >
                                    <span className="h-px w-5 shrink-0 bg-accent" />
                                    <span className="text-[15px] text-white/85">
                                        {c}
                                    </span>
                                </div>
                            ))}
                        </div>

                        <p className="border-t border-white/10 px-6 py-4 font-mono text-[13px] tracking-[0.2em] text-mist md:px-8">
                            MATCHED VIA CONTEXT — ILLUSTRATIVE INTERFACE
                        </p>
                    </div>
                </motion.div>
            </div>
        </div>
    </section>
);

export default TransparentMatching;
